import { useContext } from 'react';

import { PatientSearchContext } from './context';

const usePatientSearch = () => {
  const patientSearch = useContext(PatientSearchContext);

  return patientSearch;
};

export default usePatientSearch;
